import type { WorkoutSession } from "../types";
import { formatDate, formatDuration } from "../utils";

export function HistoryPage({ sessions }: { sessions: WorkoutSession[] }) {
  return (
    <section className="route active-route">
      <header className="page-header"><div><p className="eyebrow">CONSISTENCY</p><h1>Workout History</h1></div></header>
      <div className="history-list">
        {sessions.length ? sessions.map((session) => (
          <article className="card history-row" key={session.client_session_id}>
            <div className="day-date">{formatDate(session.started_at)}</div>
            <div className="day-main"><strong>{session.title || session.workout_type || "Workout"}</strong><small>{session.source} · {formatDuration(session.elapsed_seconds)}{session.rpe ? ` · RPE ${session.rpe}` : ""}{session.distance_km ? ` · ${session.distance_km} km` : ""}</small></div>
            <span className={`status-label ${session.status}`}>{session.status}</span>
          </article>
        )) : <section className="card empty-state"><p>Your synchronized workout sessions will appear here.</p></section>}
      </div>
    </section>
  );
}
